"use client"

import { i18n } from "@/modules/App/components/i18n/i18n.client"

export const SetupLanguage = ({ lang }: { lang?: string }): null => {
  void i18n.changeLanguage(lang)
  return null
}
